module.exports = __webpack_public_path__ + "static/img/company-8.402c5dd2.png";